import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import "leader-line";
import * as _ from "lodash";
import {ToastrService} from "ngx-toastr";
import {Bot} from "../../../../../models/bot";
import {DataMappingHelpers} from "../../../../../models/data-mapping-helpers";
import {FieldGroup} from "../../../../../models/field-group";
import {FormField} from "../../../../../models/form-field";
import {MappingBoard} from "../../../../../models/mapping-board";
import {MuleService} from "../../../../../models/mule-service";
import {ServiceField} from "../../../../../models/service-field";
import {FormControllerService} from "../../../../../services/form-controller/form-controller.service";
import {MuleControllerService} from "../../../../../services/mule-controller/mule-controller.service";
import {BotControllerService} from "../../../../../services/role-controller/bot-controller.service";
import {ServiceControllerService} from "../../../../../services/service-controller/service-controller.service";
import {Store} from "../../../../../services/store.service";
import {MuleMapping} from "../../../../../models/mule-mapping";
import {DataMapping} from "../../../../../models/data-mapping";
import {Service} from "../../../../../models/service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import { map } from 'rxjs/operators';
import { MappingService } from "src/app/services/mapping.service";

@Component({
    selector: "service-role",
    templateUrl: "./service-role.component.html",
    providers: [MuleControllerService,
        FormControllerService, BotControllerService],
})
export class ServiceRoleComponent extends TranslatedBaseError implements OnInit, OnChanges {

    @Input() public bot: Bot;
    @Input() public serviceId: string;
    @Output() public reloadData = new EventEmitter();
    @Output() public saveData = new EventEmitter();

    public mappingBoards: MappingBoard[] = [];
    public muleServices: MuleService[] = [];
    public selectedMuleService: MuleService = null;
    public allServiceFields: FormField[] = [];
    public internalAllServiceFields: FormField[] = [];
    public allFieldGroups: FieldGroup[] = [];
    public internalAllFieldGroups: FieldGroup[] = [];
    public tree: FieldGroup[] = [];
    public hideInputFields: any = {};
    public hideOutputFields: any = {};
    public hideInputFormFields: any = {};
    public hideOutputFormFields: any = {};
    public checkingVisibility: any = { value: false };
    public transformationBoardID: string;
    public transformationSwitchs: any = {};
    public allServices: Service[] = [];
    public selectedLink: any;

    public tempSelectedBoard: any = null;
    public tempSelectedBoardFilters: any = null;

    // right column fields
    public fields: any = {};
    public generateRightEstructure: boolean = false;

    public saving: boolean = false;
    // public scrolling: any = null;

    public showPanel: boolean = false;
    public onInitFinished: boolean = false;
    public checkingNewServiceLinks: boolean = false;

    // for external components
    @Output() public mappingReady: EventEmitter<boolean> = new EventEmitter();

    public showDataTransformationDrawer: boolean = false;

    public listServices: Array<{ prefix: string, suffix: string }> = [
        { prefix: "GDB", suffix: "-list" },
    ];
    public threeBoardServices: Array<{ prefix: string, suffix: string }> = [
        { prefix: "GDB", suffix: "-update-or-create" },
        { prefix: "GDB", suffix: "-update-or-create-entries" },
        { prefix: "GDB", suffix: "-update" },
        { prefix: "GDB", suffix: "-update-entries" },
    ];

    public listenServices: Array<{ prefix: string, suffix: string }> = [
        { prefix: "updateBy", suffix: "" },
    ];

    public queryAndWriteServices: Array<{ prefix: string, suffix: string }> = [
        ...this.threeBoardServices,
    ];

    public static gdbWrapperPropsToHide: Set<string> = new Set(["query", "write", "receive", "results", "content"]);

    constructor(private muleService: MuleControllerService,
                private serviceControllerService: ServiceControllerService,
                private formControllerService: FormControllerService,
                private botController: BotControllerService,
                public toastr: ToastrService,
                public mappingService: MappingService,
                private store: Store,  public translateService: TranslateService) {
        super(toastr, translateService);
        this.mappingService.refreshLines.subscribe(() => {
            console.log("refreshing lines");
            this.handleScroll();
        });
    }

    public ngOnInit(): void {
        this.saving = true;
        this.mappingBoards.push(new MappingBoard(this.selectedMuleService));
        this.getSystemFields(this.serviceId);
        if (this.bot && this.bot.botType === "internal") {
            if (!this.bot.botServiceId) {
                this.bot.botServiceId = this.serviceId;
            }
            this.getAllServices();
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.bot && (changes.bot.previousValue !== changes.bot.currentValue) && changes.bot.previousValue !== undefined && this.onInitFinished) {
            this.resetMapping();
        }
    }

    public ngOnDestroy(): void {
        this.mappingBoards.forEach((board) => this.relRemove(board));
    }

    public itemDrop(boardId: string = ""): void {
        this.updateRelationshipsPositions();
    }

    public getAllServices() {
        this.serviceControllerService.getServicesList().subscribe(
            (data) => {
                this.allServices = data.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
            },
            (error) => {
                this.showErrorMessageWithTitle("Error while updating links!", error);
            },
        );
    }

    public resetMapping(): void {
        this.mappingBoards.forEach((board) => this.relRemove(board));
        this.generateRightEstructure = false;
        this.fields = {};
        this.loadMuleServices();
    }

    public relRemove(board: MappingBoard): void {
        const linesToRemove = [];
        board.lines.forEach((line, i) => {
            if (line.line != null) {
                linesToRemove.push(i);
            }
        });
        linesToRemove.sort((a, b) => b - a).forEach((ltr) => {
            if (board.lines[ltr] && board.lines[ltr].lineId ) {
                board.removeRelationship(board.lines[ltr].lineId);
            }
        });
    }

    public standardProcessMappings(fieldMappings: DataMapping[], muleMappings: any[], board: MappingBoard, type) {
        const uniqueFieldMappings = [];
        if (this.bot && this.bot.botType === "internal") {
            muleMappings = this.internalAllServiceFields;
        }
        fieldMappings.forEach((fm) => {
            const id = DataMappingHelpers.getSanitizeID(fm.sourceField, board.leftIdPrefix);
            const left = document.getElementById(`${id}`);
            const right = board.muleServiceItems.length ? board.muleServiceItems.some((i) => i.id === fm.targetField) : muleMappings.some((i) => (i.id || i.fieldKey) === fm.targetField);
            if (!left || !right) {
                return; }
            if (!this.checkMappingInternal(fm, board)) {
                return;
            }
            if ((uniqueFieldMappings.some((ufm) => {
                return ufm.sourceField === fm.sourceField
                    && ufm.targetField === fm.targetField
                    && ufm.sourceType === fm.sourceType;
            }))) {
                return;
            } else {
                uniqueFieldMappings.push({
                    sourceField: fm.sourceField,
                    sourceType: fm.sourceType,
                    targetField: fm.targetField,
                });
            }
            if (!(muleMappings.some((mapping) => {
                if (fm.targetField !== (mapping.id || mapping.fieldKey)) {
                    return false;
                }
                board.addRelationship({
                    type,
                    field: this.getField(fm.sourceField, this.allFieldGroups),
                    input: mapping,
                    startPoint: DataMappingHelpers.getSanitizeID(fm.sourceField, board.leftIdPrefix),
                    endPoint: DataMappingHelpers.getSanitizeID((mapping.id || mapping.fieldKey), board.rightIdPrefix),
                    lineId: fm.id,
                    targetFieldProperties: fm.targetFieldProperties ? JSON.parse(fm.targetFieldProperties) : null,
                    jsonDeterminant: fm.jsonDeterminant ? fm.jsonDeterminant : null,
                    jsonDeterminantFilter: fm.jsonDeterminantFilter ? fm.jsonDeterminantFilter : null,
                });
                return true;
            }))) {
                return;
            }
        });
        board.ghostLines = [];
        const arr2Targets = board.lines.map(el => el.end.replace(/^to/, ''));
        console.log("processing ghosts", fieldMappings, board.lines, arr2Targets);
        fieldMappings.forEach((fm) => {
            const notLine = board.lines.find((l) => l.lineId === fm.id );
            const hasTarget = arr2Targets.find(target => (target === fm.targetField || target.endsWith(`-${fm.targetField}`)));
            console.log(hasTarget, fm.targetField, arr2Targets);
            if ((!notLine && (!fm.targetField || fm.targetField.startsWith(board.prefix)) || ((!hasTarget?.length || hasTarget === undefined) && this.bot.botType === "internal"))) {
                console.log("adding ghost for", fm);
                board.addGhost({
                    type,
                    field: this.getField(fm.sourceField, this.allFieldGroups),
                    input: null,
                    startPoint: fm.sourceField,
                    endPoint: fm.targetField,
                    lineId: fm.id,
                    targetFieldProperties: fm.targetFieldProperties ? JSON.parse(fm.targetFieldProperties) : null,
                    jsonDeterminant: fm.jsonDeterminant ? fm.jsonDeterminant : null,
                    jsonDeterminantFilter: fm.jsonDeterminantFilter ? fm.jsonDeterminantFilter : null,
                });
            }
        });
    }

    public checkMappingInternal(mapping, board) {
        return mapping.targetField.startsWith(board.prefix !== "internal_" ? board.prefix : "") || !mapping.sourceField;
    }

    public loadRelationships(board: MappingBoard): void {
        if (this.bot && this.bot.botServiceId && this.muleServices && this.allFieldGroups && this.allFieldGroups.length > 0 && this.selectedMuleService) {
            if (board.isQueryWriteService) {
                this.standardProcessMappings(this.bot.inputFieldsMapping, this.selectedMuleService.inputs, board, "input");
                return;
            }
            if (board.type === "input") {
                this.standardProcessMappings(this.bot.inputFieldsMapping, this.selectedMuleService.inputs, board, "input");
            }
            if (board.type === "output") {
                this.standardProcessMappings(this.bot.outputFieldsMapping, this.selectedMuleService.outputs, board, "output");
            }
        } else if (this.bot && this.internalAllFieldGroups && this.internalAllFieldGroups.length > 0 && this.bot.botType === "internal") {
            this.standardProcessMappings(this.bot.inputFieldsMapping, this.internalAllFieldGroups, board, "input");
        }
    }

    private static hideVisualLine(line): void {
        if (line.line === null) { return; }
        line.line.hide();
    }

    public checkLinesVisibility(boardId: string = ""): void {
        this.mappingBoards.filter((board) => board.id.startsWith(boardId)).forEach((board) => {
            board.lines.forEach((line) => {
               const start = document.getElementById(line.start);
               const end = document.getElementById(line.end);
               // console.log(line, start, end);
               if (start && end) {
                   const nohidden =
                       start.style.display !== "none" && !start.classList.contains("hidden")
                       && !start.classList.contains("overflowed")
                       && end.style.display !== "none"
                       && !end.classList.contains("hidden")
                       && !end.classList.contains("overflowed");

                   // add line
                   if (line.line === null) {
                       line.line = board.initLine(start, end, line);
                   }
                   if (nohidden) {
                       // remove connected-non-visible class
                       line.line.show();
                       start.classList.remove("connected-non-visible");
                       end.classList.remove("connected-non-visible");
                   } else {
                       ServiceRoleComponent.hideVisualLine(line);
                       // add connected-non-visible class
                       start.classList.add("connected-non-visible", "connected");
                       end.classList.add("connected-non-visible", "connected");
                   }
               } else {
                   ServiceRoleComponent.hideVisualLine(line);
                   // add connected-non-visible class
                   if (start) { start.classList.add("connected-non-visible", "connected"); }
                   if (end) { end.classList.add("connected-non-visible", "connected"); }
               }
           });
        });
        this.updateRelationshipsPositions();
        this.checkingVisibility.value = false;
    }

    public updateRelationshipsPositions(): void {
        this.mappingBoards.forEach((board) => {
            board.lines.filter((line) => line.line !== null).forEach((line) => {
                const start = document.getElementById(line.start);
                const end = document.getElementById(line.end);
                if (line.line) {
                    if (start && end && !start.classList.contains("overflowed") && !start.classList.contains("connected-non-visible") &&
                        !end.classList.contains("overflowed") && !end.classList.contains("connected-non-visible")) {
                      line.line.setOptions({ start, end });
                      line.line.position();
                    } else {
                        line.line.hide();
                    }
                }
            });
        });
    }

    public updateLinesVisibility(): void {
        document.querySelectorAll("div.has-scroll").forEach((region) => {
            this.handleHasScroll(region);
        });
    }

    public handleHasScroll(region: Element): void {
        region.querySelectorAll(".connected").forEach((regionField) => {
            if ((regionField.getBoundingClientRect().bottom) < (region.getBoundingClientRect().top) || regionField.getBoundingClientRect().top > region.getBoundingClientRect().bottom) {
                regionField.classList.add("overflowed");
            } else {
                regionField.classList.remove("overflowed");
            }
        });
    }

    public checkScrollableRegionsHeight(boardId: string = ""): void {
        document.querySelectorAll(".scrolled-region").forEach((region) => {
            const h = region.clientHeight;
            if (h >= 800) {
                region.classList.add("has-scroll");
            } else {
                region.classList.remove("has-scroll");
            }
            this.handleHasScroll(region);
        });
        this.checkLinesVisibility(boardId);
    }

    public loadMuleServices(): void {
        if (this.bot && this.bot.botType !== "internal") {
            this.muleService.getServicesList().subscribe(
                (data) => {
                    this.filterValidationList(data);
                    this.togglePanel(true);
                    this.onInitFinished = true;
                },
                (err) => this.showErrorMessage(err),
            );
        } else if (this.bot && (this.bot.botServiceId === this.serviceId)) {
            this.filterValidationList(null);
            this.togglePanel(true);
            this.onInitFinished = true;
        } else if (this.bot && (this.bot.botServiceId !== this.serviceId)) {
            this.formControllerService.getServiceFieldsWithComponentHierarchy(this.bot.botServiceId).subscribe(
                (data) => {
                    this.setNewRightListFields(data.sort((a, b) => a.orderNumber - b.orderNumber ).filter((f) => {
                        return f.key !== "FORM_DOCUMENT";
                    }));
                },
                (error) => this.showErrorMessageWithTitle("Unable to get service form field list!", error),
            );
        }
    }

    public filterValidationList(services: MuleService[]): void {
        if (this.bot.botType === "document") {
            if (this.bot.category === "upload" || this.bot.category === "document_generate_and_upload") {
                this.muleServices = services.filter((service) => service.id.indexOf("generic-pdf-generator") !== -1);
            } else if (this.bot.category === "document_upload") {
               this.muleServices = services.filter((service) => service.id.indexOf("generic-pdf-display") !== -1);
            } else if (this.bot.category === "display" || this.bot.category === "document_generate_and_display") {
               this.muleServices = services.filter((service) => service.id.indexOf("generic-pdf-display") !== -1);
            } else if (this.bot.category === "document_upload_to_ds") {
               this.muleServices = services.filter((service) => service.id.indexOf("document-upload-to-ds") !== -1);
            }
        } else if (this.bot.botType === "internal") {
            this.muleServices = [];
            this.mappingBoards[0].showRightSideFields = true;
        } else {
            this.muleServices = services.filter((service) => {
                if (service.type === "WSDL") {
                    return true;
                } else if (service.type === "listener") {
                    return true;
                } else if (this.bot.category === "log") {
                  return service.id.endsWith("-audit-fields");
                } else if (this.bot.category === "read") {
                    return service.id.endsWith("-read") || service.id.endsWith("-read-value");
                } else if (this.bot.category === "other") {
                    return (!(service.id.endsWith("-read") || service.id.endsWith("-read-value")
                        || service.id.endsWith("-update") || service.id.endsWith("-create")
                        || service.id.endsWith("-delete") || service.id.endsWith("-exists")
                        || service.id.endsWith("-list"))) && service.id.indexOf("GDB.") === -1;
                } else {
                    return service.id.indexOf("-" + this.bot.category) !== -1;
                }
            });
        }
        this.setSelectedMuleService({initialLoad: true});
    }

    public setBotService(serviceId: string) {
        const oldService: any = this.muleServices.find((s) => s.id === this.bot.botServiceId);
        const newService: any = this.muleServices.find((s) => s.id === serviceId);

        if (!this.bot) { return; }
        if (!this.muleServices.filter((e) => e.id === serviceId).length) { return; }
        if ((oldService && newService) && ((oldService.dbName === newService.dbName) || (oldService?.id?.split("(")[0] === newService?.id?.split("(")[0])) && (this.bot.inputFieldsMapping.length || this.bot.outputFieldsMapping.length)) {
            this.checkingNewServiceLinks = true;
            this.updateBotMapping(serviceId, oldService, newService);
        } else {
            this.setNewBotService(serviceId);
        }
    }

    public changeBotService(serviceId: any) {
        this.bot.botServiceId = serviceId;
        this.mappingBoards.forEach((board) => this.relRemove(board));
        this.saveData.emit();
        this.loadMuleServices();
    }

    public deleteLine(id): void {
        this.botController.deleteBotInputMapping(id).subscribe((answer) => {
            console.log(answer);
        });
    }

    public updateBotMapping(serviceId: string, oldService: any, newService: any) {
        const promises = [];
        if (!this.selectedMuleService) {
            promises.push(
                this.muleService.getService(btoa(oldService.id)).pipe(map(
                (data) => {
                    return data;
                },
                )).toPromise(),
            );
        }
        promises.push(
            this.muleService.getService(btoa(newService.id)).pipe(map(
            (data) => {
                return data;
            },
            )).toPromise(),
        );
        Promise.all<any[]>(promises).then((results: any[]) => {
            if (this.selectedMuleService) {
                this.compareServices(serviceId, this.selectedMuleService, results[0]);
            } else {
                this.compareServices(serviceId, results[0], results[1]);
            }

        });
    }

    public compareServices(serviceId: string, oldService: any, newService: any) {
        let needsInputsSave = false;
        let needsOutputsSave = false;
        this.bot.inputFieldsMapping.forEach((inputMapping) => {
            const oldInput = oldService.inputs.find((i) => (i.id === inputMapping.targetField));
            const tempNewInput = oldInput ? newService.inputs.filter((i) => (i.fieldId === oldInput.fieldId) && (i.id.split("_")[0] === oldInput.id.split("_")[0])) : false;
            let newInput;
            if (tempNewInput && tempNewInput.length < 2) {
                newInput = tempNewInput[0];
            } else if (tempNewInput && tempNewInput.length > 1) {
                const exactMatch = tempNewInput.find((i) => (i.id === oldInput.id));
                if (exactMatch) {
                    newInput = exactMatch;
                } else {
                    const tempOldId = oldInput.id.replace("__", "_");
                    tempNewInput.forEach((n) => {
                        const tempNewId = n.id.replace("__", "_");
                        if (tempNewId.split("_").length === tempOldId.split("_").length) {
                            newInput = n;
                        }
                    });
                }
            }
            if (oldInput && newInput && oldInput.id !== newInput.id && oldInput.fieldId && newInput.fieldId) {
                inputMapping.targetField = newInput.id;
                needsInputsSave = true;
            }
        });
        this.bot.outputFieldsMapping.forEach((outputMapping) => {
            const oldInput = oldService.outputs.find((i) => i.id === outputMapping.targetField);
            const tempNewInput = oldInput ? newService.outputs.filter((i) => i.fieldId === oldInput.fieldId) : false;
            let newInput;
            if (tempNewInput && tempNewInput.length < 2) {
                newInput = tempNewInput[0];
            } else if (tempNewInput && tempNewInput.length > 1) {
                const exactMatch = tempNewInput.find((i) => (i.id === oldInput.id));
                if (exactMatch) {
                    newInput = exactMatch;
                } else {
                    const tempOldId = oldInput.id.replace("__", "_");
                    tempNewInput.forEach((n) => {
                        const tempNewId = n.id.replace("__", "_");
                        if (tempNewId.split("_").length === tempOldId.split("_").length) {
                            newInput = n;
                        }
                    });
                }
            }
            if (oldInput && newInput && oldInput.id !== newInput.id && oldInput.fieldId && newInput.fieldId) {
                outputMapping.targetField = newInput.id;
                needsOutputsSave = true;
            }
        });
        if (needsOutputsSave || needsInputsSave) {
            this.bot.botServiceId = serviceId;
            this.botController.saveBot(this.bot).subscribe(
                (rslt) => {
                    this.saveLines({input: needsInputsSave, output: needsOutputsSave, cb: this.setNewBotService(serviceId, false)});
                },
                (error) => this.showErrorMessageWithTitle("Error while updating links!", error));
        } else {
            this.setNewBotService(serviceId);
        }
    }

    public setNewBotService(serviceId, needsBotSave: boolean = true) {
        this.checkingNewServiceLinks = false;
        this.bot.botServiceId = serviceId;
        // for right structure reload
        this.generateRightEstructure = false;
        this.mappingBoards.forEach((board) => this.relRemove(board));
        this.setSelectedMuleService({updateBoards: true}, needsBotSave);
    }

    public setSelectedMuleService(args: any, needsBotSave: boolean = true): void {
        if (this.bot && this.bot.botServiceId && this.muleServices.length > 0) {
            if (!this.muleServices.some((e) => e.id === this.bot.botServiceId)) {
                // botServiceId is expired and not used anymore
                this.bot.botServiceId = null;
                this.showErrorMessageWithTitle("Error loading remote service", "Service is not longer available!");
                this.mappingReady.emit(true);
                return;
            }
            if (args.initialLoad || args.updateBoards) { this.mappingBoards = []; }
            this.muleService.getService(btoa(this.bot.botServiceId)).subscribe((data) => {
                this.selectedMuleService = data;

                if (!this.selectedMuleService) {
                    this.bot.botServiceId = null;
                    this.mappingReady.emit(true);
                    return this.resetMapping();
                }

                // define type of service we are dealing with
                const listService = this.listServices.some((qws) =>
                    this.selectedMuleService.id.startsWith(qws.prefix) && this.selectedMuleService.id.endsWith(qws.suffix));
                const queryAndWriteService = this.queryAndWriteServices.some((qws) =>
                    this.selectedMuleService.id.startsWith(qws.prefix) && this.selectedMuleService.id.endsWith(qws.suffix));
                const threeBoardService = this.threeBoardServices.some((qws) =>
                    this.selectedMuleService.id.startsWith(qws.prefix) && this.selectedMuleService.id.endsWith(qws.suffix));
                const listenService = this.listenServices.some((qws) =>
                    this.selectedMuleService.id.startsWith(qws.prefix));

                if (!listenService) {
                    // Add grid field to input so link can be created
                    this.addFakeGrid(this.selectedMuleService.inputs);
                    this.selectedMuleService.inputs.forEach((input) => {
                        // console.log(input);
                        const fieldKey = this.bot.inputFieldsMapping.find((field) => field.targetField === input.id);
                        if (!input.fieldName) {
                            input.fieldName = "";
                        }
                        if (fieldKey && fieldKey.sourceField) {
                            const arrayOfSourcefield = fieldKey.sourceField.split("/");
                            let selectedValue: any;
                            if (arrayOfSourcefield && arrayOfSourcefield.length === 3) { // we should ignore the catalogue version
                                selectedValue = this.allServiceFields.find((k) => (k.fieldKey.indexOf(arrayOfSourcefield[0]) >= 0
                                    && k.fieldKey.indexOf(arrayOfSourcefield[2]) >= 0));
                            } else {
                                selectedValue = this.allServiceFields.find((k) => k.fieldKey === fieldKey.sourceField);
                            }
                            if (selectedValue) {
                                input.fieldName = selectedValue.formTitle + "." + selectedValue.label;
                            } else {
                                input.fieldName = fieldKey.sourceField;
                            }
                        } else if (input.fieldName) {
                            input.fieldName = undefined;
                        }
                        if (args.initialLoad) {
                            this.hideInputFields[input.name] = this.bot.hiddenInputServiceFields
                                && JSON.parse(this.bot.hiddenInputServiceFields).indexOf(input.name) > -1;
                        }
                    });
                    this.pushBoard(args, queryAndWriteService, queryAndWriteService ? "query_" : "", 0);
                }
                // Add grid field to input so link can be created
                this.addFakeGrid(this.selectedMuleService.outputs);
                this.selectedMuleService.outputs.forEach((output) => {
                    const fieldKey = this.bot.outputFieldsMapping.find((field) => field.targetField === output.id);
                    if (!output.fieldName) { output.fieldName = ""; }
                    if (fieldKey) {
                        const selectedValue = this.allServiceFields.find((k) => k.fieldKey === fieldKey.sourceField);
                        if (selectedValue) {
                            output.fieldName = selectedValue.formTitle + "." + selectedValue.label;
                        }
                    } else if (output.fieldName) {
                        output.fieldName = undefined;
                    }
                    if (args.initialLoad) {
                        this.hideOutputFields[output.name] = this.bot.hiddenOutputServiceFields
                            && JSON.parse(this.bot.hiddenOutputServiceFields).indexOf(output.name) > -1;
                    }
                });
                this.pushBoard(args, queryAndWriteService, queryAndWriteService ? "write_" : "", listenService ? 0 : 1,
                    queryAndWriteService, queryAndWriteService ? "input" : "output");

                if (threeBoardService) {
                    this.pushBoard(args, false, "", 2, false, "output");
                }

                if ((!args.initialLoad || args.onlyProcessFields) && needsBotSave) { this.saveData.emit(); }
                if (!args.onlyProcessFields && !this.generateRightEstructure) { this.generateRightFieldsStructure(queryAndWriteService, threeBoardService, listService, listenService); }

                if (this.fields[this.selectedMuleService.id]) {
                    Object.entries(this.fields[this.selectedMuleService.id]).forEach(([key, board]) => {
                        this.fields[this.selectedMuleService.id][key].forEach((item) => {
                            this.generateRightItemsLevel(item, null);
                        });
                    });
                }
                // console.log(this.fields);
                this.initBoardsLines();
                this.mappingReady.emit(true);
            });
        } else if (this.bot && this.bot.botType === "internal") {
            this.mappingBoards = [];
            this.pushBoard(args, false, "internal_", 0, false, "input");
            this.mappingBoards[0].showRightSideFields = true;
            this.mappingBoards[0].isLtr = true;
            this.mappingBoards[0].leftIdPrefix = "from";
            this.mappingBoards[0].rightIdPrefix = "to";
            this.mappingReady.emit(true);
            this.initBoardsLines();
        } else {
            this.bot.botServiceId = null;
            this.mappingReady.emit(true);
        }
    }

    private addFakeGrid(fields) {
        fields.forEach((field) => {
            if (field.parentFieldId && field.parentFieldId.length && !fields.find((f) => f.fieldId === field.parentFieldId)) {
                const path = ServiceRoleComponent.getFieldPath(field.id);
                fields.push({
                    fieldId: field.parentFieldId,
                    type: "editgrid",
                    id: field.id.substring(0, field.id.lastIndexOf("_collection_")),
                    name: path[path.length - 2],
                });
            }
        });
    }

    private pushBoard(args: any, queryAndWriteService: boolean, prefix: string, index: number, isLtr: boolean = true, type: string = "input"): void {
        let board;
        if (!args.onlyProcessFields) {
            if (args.initialLoad || args.updateBoards) {
                board = new MappingBoard(this.selectedMuleService, queryAndWriteService, prefix, index, isLtr, type);
                this.mappingBoards.push(board);
            } else {
                board = this.mappingBoards.length > index ? this.mappingBoards[index] : false;
            }
            // replaced by initBoardsLines()
            // if (board) { this.getBoardVisibility(board); }
        }
    }

    public initBoardsLines() {
        this.mappingBoards.forEach((board) => {
            this.getBoardVisibility(board);
        });
    }

    public saveLines(args) {
        this.saving = true;
        const successCb = (rslt) => {
            this.extractIds(rslt);
            this.saving = false;
            this.responseSuccessful("Saved successfully!");
            this.handleScroll();
            if (args && args.cb && typeof args.cb === "function") { return args.cb(); }
        };
        const errorCb = (error: any) => {
            this.ngOnInit();
            return this.showErrorMessageWithTitle("Error during save/update of bot mappings!", error);
        };

        const promises = [];
        if (args && args.input) {
            promises.push(this.botController.saveBotsInputMappings(this.bot.id, this.bot.inputFieldsMapping).toPromise());
        }
        if (args && args.output) {
            promises.push(this.botController.saveBotsOutputMappings(this.bot.id, this.bot.outputFieldsMapping).toPromise());
        }
        return Promise.all(promises).then((rslt) => successCb(rslt), errorCb);
    }

    private static findGroup(array, name): number {
        return array.findIndex((field) => field.isgroup && field.name === name);
    }

    private static pushField(muleMapping: MuleMapping, array: any[]): void {
      // before push make sure that element with same id doesn't already exist
      // console.log(muleMapping.name, array);
      if (!array.length || array.filter((item) => item?.field?.id).map((item) => item.field.id).every((id) => id !== muleMapping.id)) {
        array.push({
          filter: muleMapping.name,
          field: muleMapping,
          isgroup: false,
        });
       }
    }

    private extractIds(lines) {
        if (lines && lines.length && lines[0] !== "") {
            const allLines = JSON.parse(lines[0]);
            this.mappingBoards.filter((mb) => mb.lines).forEach((mb) => {
                const mbLine = mb.lines.find((l) => !l.lineId);
                let updatedLine;
                if (!mbLine) {
                    return;
                } else {
                    updatedLine = allLines.find((al) => al.sourceField === mbLine.field.fieldKey && al.targetField === mbLine.input.id);
                }
                if (mbLine && updatedLine) { mbLine.lineId = updatedLine.id; }
            });
            const botLine = this.bot.inputFieldsMapping.find((l) => !l.id);
            let updatedLineBis;
            if (!botLine) {
                return;
            } else {
                updatedLineBis = allLines.find((al) => al.sourceField === botLine.sourceField && al.targetField === botLine.targetField);
            }
            if (botLine && updatedLineBis) { botLine.id = updatedLineBis.id; }
        }
    }

    private static getFieldPath(input_id, listService: boolean = false): any[] {
        // currently this splits string either by "_child_" or "_collection_"
        // in cas of not listService. Later the array will be joined into a
        // string using "_child_" separator even in case split was done using
        // "_collection_". This is fine because there is no visual difference
        // between a webservice block and webservice edit grid
        input_id = input_id.replace("_*_child_", "_");
        input_id = input_id.replace("_collection_item", "");
        return input_id.split(/\_child\_|\_collection\_/g);
    }

    private static getGridPath(input_id): any {
        return input_id.substring(0, input_id.lastIndexOf("_collection_"));
    }

    private static pushGroup(id: string, muleMapping: MuleMapping, array: any[], listService: boolean, open: boolean = true): void {
        const fieldPath = ServiceRoleComponent.getFieldPath(id, listService);
        // we don't want to display wrapper property.
        if (ServiceRoleComponent.gdbWrapperPropsToHide.has(fieldPath[0]) || !open) { fieldPath.shift(); } // remove root wrapper
        if (open && ServiceRoleComponent.gdbWrapperPropsToHide.has(fieldPath[0])) { fieldPath.shift(); } // remove "content" wrapper
        // if fieldPath length > 1 ==> we are dealing with a group
        // console.log(array, muleMapping.name, fieldPath);
        if (fieldPath.length > 1) {
            const groupposition = ServiceRoleComponent.findGroup(array, fieldPath[0]);
            if (groupposition === -1) {
                const groupField = {
                    name: fieldPath[0],
                    filter: fieldPath[0] + muleMapping.name,
                    items: [],
                    isgroup: true,
                    isopen: false,
                    fieldId: muleMapping.parentFieldId || this.getGridPath(muleMapping.id),
                    type: null,
                    field: null,
                };
                if ((muleMapping.type !== "file") && muleMapping.id.lastIndexOf("_collection_") !== -1 &&
                  (muleMapping.id.lastIndexOf("_child_") === -1 ||
                    (muleMapping.id.lastIndexOf("_collection_") > muleMapping.id.lastIndexOf("_child_")))) {
                    const fieldGroup = {
                        isgroup: false,
                        filter: fieldPath[0],
                        fieldId: muleMapping.parentFieldId,
                        field: {
                            fieldId: muleMapping.parentFieldId,
                            id: this.getGridPath(muleMapping.id),
                            name: fieldPath[0],
                            type: "editgrid",
                        },
                    };

                    groupField.field = {
                        fieldId: muleMapping.parentFieldId,
                        id: this.getGridPath(muleMapping.id),
                        name: fieldPath[0],
                        type: "editgrid",
                    };
                    groupField.type = "editgrid";
                    groupField.items.push(fieldGroup);
                }
                array.push(groupField);
            } else {
                array[groupposition].filter += muleMapping.name;
            }
            const lastItem = array.slice(-1)[0];
            if (!lastItem.items) {
                lastItem.items = [];
            }
            return ServiceRoleComponent.pushGroup(fieldPath.join("_child_"),
                muleMapping, lastItem.items, listService, false);
        }
        ServiceRoleComponent.pushField(muleMapping, array);
    }

    public generateRightFieldsStructure(secondBoardLtr: boolean = false, threeBoardService: boolean = false, listService: boolean = false, listenService: boolean = false): void {
        this.generateRightEstructure = true;
        this.fields = {};
        this.fields[this.selectedMuleService.id] = {};
        this.fields[this.selectedMuleService.id]["0"] = [];
        this.fields[this.selectedMuleService.id]["1"] = [];
        if (threeBoardService) { this.fields[this.selectedMuleService.id]["2"] = []; }
        this.selectedMuleService.inputs.filter((input) => {
            if ((input.name === "key" || input.name === "value") && (String(input.id).endsWith("_child_key") || String(input.id).endsWith("_child_value")) || String(input.id).length < 1) {
                return false;
            }
            return true;
        }).forEach((input) => {
            const showInNextBoard = secondBoardLtr && input.id.startsWith("write_");
            return ServiceRoleComponent.isGroupField(input.id, input.type)
                ? ServiceRoleComponent.pushGroup(input.id, input, this.fields[this.selectedMuleService.id][showInNextBoard ? "1" : "0"], listService)
                : ServiceRoleComponent.pushField(input, this.fields[this.selectedMuleService.id][showInNextBoard ? "1" : "0"]);
        });

        if (secondBoardLtr && !threeBoardService) { return; }

        // here we have to filter only unique output ids due to GDB's swagger behaviour of returning
        // response mappings separately for every type of possible response.  So in case for GDB can
        // return different types of successful response messages like 201, 204 for example then that
        // will duplicate the response fields here.
        const uniqueIds = new Set();
        this.selectedMuleService.outputs.filter((muleMapping) => {
            if (uniqueIds.has(muleMapping.id) || !muleMapping.id?.length) { return false; }
            uniqueIds.add(muleMapping.id);
            return true;
        }).forEach((input) => {
            return ServiceRoleComponent.isGroupField(input.id, input.type)
                ? ServiceRoleComponent.pushGroup(input.id, input, this.fields[this.selectedMuleService.id][threeBoardService ? "2" : (listenService ? "0" : "1")], false)
                : ServiceRoleComponent.pushField(input, this.fields[this.selectedMuleService.id][threeBoardService ? "2" : (listenService ? "0" : "1")]);
        });
    }

    public generateRightItemsLevel(item, lvl) {
        item.level = lvl ? Number(lvl) + 1 : 1;
        if (item.items && item.items.length) {
            const isCatalog = [];
            item.items.forEach((i) => {
                if (i.filter && (i.filter.includes(".key") || i.filter.includes(".value")) && !i.isgroup) {
                    isCatalog.push(i.filter.includes(".key") || i.filter.includes(".value"));
                }
                this.generateRightItemsLevel(i, item.level);
            });
            if (isCatalog.length > 1) {
                item.type = "catalog";
            }
        }
    }

    public static isGroupField(input_id, type: any = null): boolean {
        return (((input_id.indexOf("child") !== -1) || (input_id.indexOf("collection") !== -1) || (input_id.indexOf("content") !== -1) || (input_id.split(".").length > 2)));
    }

    // fix for relationships visibility
    public togglePanel(value): void {
        this.showPanel = value;
        if (this.showPanel) {
            this.mappingBoards.filter((board) => board.showBoard.value).forEach((board) => {
                this.loadRelationships(board);
            });
            if (this.mappingBoards.find((board) => board.showBoard.value)) {
                if (!this.checkingVisibility.value) {
                    this.checkingVisibility.value = true;
                    this.handleScroll();
                }
            }
        } else {
            ServiceRoleComponent.hideLines(this.mappingBoards);
        }
    }

    private static hideLines(boards: MappingBoard[]): void {
        boards.forEach((board) => {
            board.lines.filter((line) => line.line && typeof line.line.hide === "function").forEach((line) => {
                line.line.hide();
            });
        });
    }

    public sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };

    public scrolling = async (boardId, boards) => {
        await this.sleep(150);
        boards.forEach((board) => {
            board.lines.forEach((line) => { if (line.line && typeof line.line.hide === "function") { line.line.show(); }});
        });
        this.checkScrollableRegionsHeight(boardId);
    };

    public handleScroll(boardId: string = ""): void {
        const boards = this.mappingBoards.filter((board) => board.id.startsWith(boardId));
        ServiceRoleComponent.hideLines(boards);
        this.scrolling(boardId, boards);
    }

    public getBoardVisibility(board: MappingBoard): void {
        const indexVal = (this.serviceId ? this.serviceId : 0) + this.bot.id + (this.selectedMuleService ? this.selectedMuleService.id : 0) + board.boardIndex;
        const state = this.store.state.common.botServicesBoards.get((this.serviceId ? this.serviceId : 0), this.bot.id, (this.selectedMuleService ? this.selectedMuleService.id : 0), board.boardIndex);
        if (state === -1) {
            this.store.state.common.botServicesBoards.servicesBots[indexVal] = false;
            this.setBoardVisibility({ board, value: true });
        } else {
            this.store.state.common.botServicesBoards.servicesBots[indexVal] = state;
            this.setBoardVisibility({ board, value: state });
        }
    }

    public setBoardVisibility(options): void {
        this.store.state.common.botServicesBoards.set((this.serviceId ? this.serviceId : 0), this.bot.id, (this.selectedMuleService ? this.selectedMuleService.id : 0), options.board.boardIndex, options.value);
        options.board.showBoard.value = options.value;
        if (options.value) {
            if (this.showPanel) {
                this.loadRelationships(options.board);
                if (options.clickHandler) {
                    if (!this.checkingVisibility.value) {
                        this.checkingVisibility.value = true;
                        this.handleScroll();
                    }
                }
            }
        } else {
            ServiceRoleComponent.hideLines([options.board]);
        }
    }

    public updateHiddenServiceFields(): void {
        this.bot.hiddenOutputServiceFields =
            JSON.stringify(Object.keys(this.hideOutputFields).filter((key) => this.hideOutputFields[key]));
        this.bot.hiddenInputServiceFields =
            JSON.stringify(Object.keys(this.hideInputFields).filter((key) => this.hideInputFields[key]));
        this.bot.hiddenOutputFormFields =
            JSON.stringify(Object.keys(this.hideOutputFormFields).filter((key) => this.hideOutputFormFields[key]));
        this.bot.hiddenInputFormFields =
            JSON.stringify(Object.keys(this.hideInputFormFields).filter((key) => this.hideInputFormFields[key]));
        this.saveData.emit();
    }

    public getSystemFields(serviceId: string): void {
        this.formControllerService.getServiceFieldsWithComponentHierarchy(serviceId).subscribe(
            (data) => {
                this.reloadFormArray(data.sort((a, b) => a.orderNumber - b.orderNumber ).filter((f) => {
                    return (f.key !== "FORM_DOCUMENT" && f.type !== "button");
                }));
            },
            (error) => this.showErrorMessageWithTitle("Unable to get service form field list!", error),
        );
    }

    // helper method to improve tree data
    private addItems(components: any[], formName: string) {
        components.forEach((field) => {
            // console.log(field);
            if (field.type === "datagrid" || field.type === "editgrid") {
                const fakeGrid = Object.assign({}, field);
                fakeGrid.components = null;
                field.components?.push(fakeGrid);
            }
            if (field.fullKey) {
                field.key = field.fullKey;
            }
            if (field.formType) {
                formName = field.formType;
            }
            field.form = formName;
            if (field.components) {
                field.components = field.components.sort((a, b) => a.keyOrder - b.keyOrder ).filter((f) => {
                    return f.type !== "button";
                });
                field.leaf = false;
                field.items = field.components;
                this.addItems(field.items, formName);
           } else {
               field.leaf = true;
           }
        });
    }

    public reloadFormArray(forms: ServiceField[]): void {
        this.allServiceFields = [];
        this.internalAllServiceFields = [];
        this.allFieldGroups = [];
        this.internalAllFieldGroups = [];
        // console.log(forms);
        this.addItems(forms, null);
        forms.forEach((field) => {
            let fieldGroup = null;
            fieldGroup = new FieldGroup();
            fieldGroup.level = 1;
            this.parseChildren(field, fieldGroup, field.form, 0, this.allServiceFields, this.internalAllServiceFields);
            fieldGroup.items = field.items;
            fieldGroup.groupName = field.form;
            fieldGroup.name = field.form;
            fieldGroup.orderNumber = field.orderNumber;
            fieldGroup.level = 1;
            this.allFieldGroups.push(fieldGroup);
            this.internalAllFieldGroups.push(fieldGroup);
        });
        this.buildTree();
        this.loadMuleServices();
    }

    public setNewRightListFields(forms: ServiceField[]): void {
        this.internalAllServiceFields = [];
        this.internalAllFieldGroups = [];
        this.addItems(forms, null);
        forms.forEach((field) => {
            let fieldGroup = null;
            fieldGroup = new FieldGroup();
            fieldGroup.level = 1;
            this.parseChildren(field, fieldGroup, field.form, 0, null, this.internalAllServiceFields);
            fieldGroup.items = field.items;
            fieldGroup.groupName = field.form;
            fieldGroup.name = field.form;
            fieldGroup.orderNumber = field.orderNumber;
            fieldGroup.level = 1;
            this.internalAllFieldGroups.push(fieldGroup);
        });
        this.filterValidationList(null);
        this.togglePanel(true);
        this.onInitFinished = true;
    }

    public orderGroupItems(group) {
        if (group && group.items && group.items.length) {
            group.items.sort((a, b) => {
                return a.orderNumber < b.orderNumber;
            });
            group.items.forEach((i) => {
                this.orderGroupItems(i);
            });
        }
    }

    public parseChildren(field: ServiceField, fieldGroup: any, fieldGroupName: string, lvl: number, allServiceFields: any, internalAllServiceFields: any) {
        const formField = this.createFormField(field, lvl ? Number(lvl) + 1 : 1);
        formField.formTitle = fieldGroupName;
        fieldGroup.fields.push(formField);
        if (allServiceFields)  {
            allServiceFields.push(formField);
        }
        internalAllServiceFields.push(formField);
        field.isgroup = !field.leaf;
        field.level = lvl ? Number(lvl) + 1 : 1;
        if (field.isgroup) {
        // TODO: why name is null/undefined?
            if (field.name == null) {
                field.name = "";
            }
            field.tree = field.name;
        }
        field.fieldName = field.name;
        field.typeclass = DataMappingHelpers.getFieldClass(field.type, field.multiple);
        field.field = formField;
        if (field.items) {
            field.items.forEach((item) => {
                this.parseChildren(item, fieldGroup, fieldGroupName, field.level, allServiceFields, internalAllServiceFields);
            });
        }
    }

    public isStatusField(field: ServiceField) {
        const checkValues = field.values?.filter((v) => {
            return v.value === "true" || v.value === "false";
        });
        return field.values && (checkValues.length === field.values.length);
    }

    public createFormField(field: ServiceField, lvl: number) {
        const formField = new FormField();
        formField.fieldKey = field.key;
        formField.formTitle = field.form;
        formField.type = field.type;
        formField.disabled = field.disabled;
        formField.level = lvl;
        formField.orderNumber = field.orderNumber;
        formField.remoteType = this.setFieldRemoteType(field.type);
        if (field.name && field.name.toLocaleLowerCase() === "catalog") {
            field.name = "Value + internal key";
        }
        if (field.name && field.name.toLocaleLowerCase() === "key") {
            field.name = "Internal key";
            formField.type = "KEY";
            field.type = "KEY";
            // formField.remoteType = "KEY";
        }
        if (field.key && field.key.includes("CATALOG_EXTERNAL_KEY")) {
            formField.type = "KEY";
            field.type = "KEY";
            // formField.remoteType = "KEY";
        }
        if (field && field.name && field.name.startsWith("Role ")) {
            field.name = field.name.slice(4);
        }
        if (field.name && this.isStatusField(field) && field.type === "radio") {
            formField.remoteType = "boolean";
        }
        formField.fieldName = field.name;
        formField.label = field.name;
        formField.filter = field.filter;
        if (field.dataSrc) {
            formField.dataSrc = field.dataSrc;
        }
        if (formField.type === "CLASSIFICATION" || formField.type === "catalog" || formField.type === "KEY") {
            formField.filter = null;
            field.filter = null;
        }
        // Hide content fields - to remove if needed
        if (field.type === "htmlelement") {
            formField.inputHidden = true;
            formField.outputHidden = true;
        }
        if (formField.label && formField.label.indexOf("value to key") !== -1) {
            formField.inputHidden = true;
            formField.outputHidden = true;
        }
        if (formField.fieldKey && formField.fieldKey.indexOf("VALUE_TO_KEY") !== -1) {
            formField.inputHidden = false;
            formField.outputHidden = false;
        }
        if (field.formType === "ROLE" && field.key.endsWith("selection") && lvl === 2) {
            formField.inputHidden = true;
            formField.outputHidden = true;
        }
        /*
        if (field.form === "ROLE" && lvl === 3) {
            formField.inputHidden = true;
            formField.outputHidden = true;
        }
        */
        return formField;
    }

    public setFieldRemoteType(type: string) {
        if (type) {
            switch (type.toLowerCase()) {
                case "editgrid":
                    return "editgrid";
                case "datagrid":
                    return "datagrid";
                case "date":
                case "datetime":
                case "date-time":
                    return "date";
                case "numeric":
                case "number":
                case "decimal":
                case "integer":
                    return "Number";
                case "checkbox":
                // case "selectboxes":
                //     return "checkbox";
                case "boolean":
                    return "Boolean";
                case "document":
                case "fileupload":
                case "file":
                case "requirement":
                case "result":
                case "fileupload":
                    return "file";
                case "classification":
                case "catalog":
                case "select":
                    return "catalog";
                // case "fileupload":
                    // return "fileupload";
                case "radio":
                     return "radio";
                // case "checkbox":
                case "button":
                    return "button";
                case "selectboxes":
                case "text":
                case "string":
                case "textfield":
                case "mycontent":
                default:
                    return "string";
            }
        } else {
            return "Text";
        }
    }

    public buildTree(): void {
       this.saving = false;
    }

    public getField(fieldKey: string, groups: any): FormField {
        let field = null;
        groups.some((afg) => {
            return afg.fields.some((f) => {
                if (f.fieldKey === fieldKey) {
                    field = f;
                    return true;
                }
            });
        });
        return field;
    }

    public onAddDataTransformation(dt): void {
        // enter in data transformation
        // item: fielditem or branch

        this.transformationBoardID = dt.item.boardId ? dt.item.boardId : "";
        this.transformationSwitchs = dt ? dt : {};
        if (this.mappingBoards) {
            const board = this.mappingBoards.find((mp) => mp.id === dt.item.boardId);
            this.transformationSwitchs.lines = board && board.lines || [];
        }
        this.selectedLink = dt;
        // console.log(dt, this.transformationSwitchs);
        this.showDrawer();
    }

    public showDrawer() {
        this.showDataTransformationDrawer = true;
        if (this.mappingBoards) {
            ServiceRoleComponent.hideLines(this.mappingBoards);
        }
    }

    public hideDrawer() {
        this.showDataTransformationDrawer = false;
        this.transformationSwitchs = {};
        if (this.mappingBoards) {
            this.handleScroll();
        }
    }

    public saveInputTransformations(line) {
        this.saving = true;
        this.botController.updateBotInputMapping(line).subscribe(
            (d) => {
            console.log(d);
            },
            (error) => this.showErrorMessageWithTitle("Error updating transformations", error),
        );
    }

    public saveOutputTransformations(line) {
        this.saving = true;
        this.botController.updateBotOutputMapping(line).subscribe(
            (d) => {
            this.saving = false;
            this.responseSuccessful("Saved successfully!");
            this.handleScroll();
            },
            (error) => this.showErrorMessageWithTitle("Error updating transformations", error),
        );
    }

    public saveTransformation(event) {
        console.log("--- saveTransformation", event);
        this.showDataTransformationDrawer = false;
        if (event.data) {
            if (event.switchs.boardType === "query" || event.switchs.boardType === "write") {
                const board = this.mappingBoards.find((mp) => mp.id === event.switchs.item.boardId);
                const mappedLine = _.find(this.bot.inputFieldsMapping, (m) => {
                    return m.sourceField === event.switchs.item.field.field.fieldKey && m.targetField === (event.switchs.item.field.input.id || event.switchs.item.field.input.fieldKey);
                });
                if (mappedLine) {
                    mappedLine.targetFieldProperties = JSON.stringify(event.data);
                }
                const updatedLine = Object.assign({}, _.find(board.lines, (l) => {
                    return l.start === event.switchs.item.field.start && l.end === event.switchs.item.field.end;
                }));
                const index = board.lines.indexOf(board.lines.find((l) => l.start === event.switchs.item.field.start && l.end === event.switchs.item.field.end));
                if (updatedLine) {
                    updatedLine.targetFieldProperties = event.data;
                }
                if (event.jsonDeterminant) {
                    if (mappedLine) {
                        mappedLine.jsonDeterminant = event.jsonDeterminant;
                    }
                    if (updatedLine) {
                        updatedLine.jsonDeterminant = event.jsonDeterminant;
                    }
                }
                if (event.jsonDeterminantFilter) {
                    if (mappedLine) {
                        mappedLine.jsonDeterminantFilter = event.jsonDeterminantFilter;
                    }
                    if (updatedLine) {
                        updatedLine.jsonDeterminantFilter = event.jsonDeterminantFilter;
                    }
                }
                // check if many to one
                // console.log(event, board.lines, mappedLine, updatedLine);
                board.lines[index] = updatedLine;
                // const promises = [this.saveInputTransformations(mappedLine)];
                const promises = [];
                promises.push(
                    this.botController.updateBotInputMapping(mappedLine).pipe(map(
                        (data) => {
                            return data;
                        },
                    )).toPromise(),
                );

                const otherManyToOne = [...board.lines.filter((l) => l.start !== event.switchs.item.field.start && l.end === event.switchs.item.field.end)];
                if (otherManyToOne.length) {
                    otherManyToOne.forEach((o) => {
                        console.log(o);
                        if (o.targetFieldProperties) {
                            const tempProps = o.targetFieldProperties;
                            tempProps.sortByFields = event.data.sortByFields;
                            o.targetFieldProperties = tempProps;
                        } else {
                            o.targetFieldProperties = event.data;
                        }
                        console.log(board.lines, o);
                        const lineIndex = board.lines.indexOf(board.lines.find((l) => l.lineId === o.lineId ));
                        const updatemto = this.bot.inputFieldsMapping.find((i) => {
                            return i.sourceField === o.field.fieldKey && i.targetField === (event.switchs.item.field.input.id || event.switchs.item.field.input.fieldKey);
                        });
                        if (updatemto.targetFieldProperties) {
                            const tempProps = o.targetFieldProperties;
                            tempProps.sortByFields = event.data.sortByFields;
                            updatemto.targetFieldProperties = JSON.stringify(tempProps);
                        } else {
                            updatemto.targetFieldProperties = JSON.stringify(event.data);
                        }
                        board.lines[lineIndex] = o;
                        // promises.push(this.saveInputTransformations(updatemto));
                        promises.push(
                            this.botController.updateBotInputMapping(updatemto).pipe(map(
                                (data) => {
                                    return data;
                                },
                            )).toPromise(),
                        );
                    });

                }

                Promise.all<any[]>(promises).then((results: any[]) => {
                    console.log(results);
                    this.saving = false;
                    this.responseSuccessful("Saved successfully!");
                    this.handleScroll();
                    return;
                });
                // return this.saveLines({ input: true });
            }
            if (event.switchs.boardType === "receive") {
                // console.log(event, this.bot.outputFieldsMapping);
                const board = this.mappingBoards.find((mp) => mp.id === event.switchs.item.boardId);
                const mappedLine = _.find(this.bot.outputFieldsMapping, (m) => {
                    return m.sourceField === event.switchs.item.field.fieldKey && m.targetField === (event.switchs.item.input.id || event.switchs.item.input.fieldKey);
                });
                if (mappedLine) {
                    mappedLine.targetFieldProperties = JSON.stringify(event.data);
                }
                const updatedLine = Object.assign({}, _.find(board.lines, (l) => {
                    return l.start === event.switchs.item.start && l.end === event.switchs.item.end;
                }));
                const index = board.lines.indexOf(board.lines.find((l) => l.start === event.switchs.item.start && l.end === event.switchs.item.end));
                if (updatedLine) {
                    updatedLine.targetFieldProperties = event.data;
                }
                if (event.jsonDeterminant) {
                    if (mappedLine) {
                        mappedLine.jsonDeterminant = event.jsonDeterminant;
                    }
                    if (updatedLine) {
                        updatedLine.jsonDeterminant = event.jsonDeterminant;
                    }
                }
                if (event.jsonDeterminantFilter) {
                    if (mappedLine) {
                        mappedLine.jsonDeterminantFilter = event.jsonDeterminantFilter;
                    }
                    if (updatedLine) {
                        updatedLine.jsonDeterminantFilter = event.jsonDeterminantFilter;
                    }
                }
                board.lines[index] = updatedLine;
                // return this.saveLines({ output: true });
                return this.saveOutputTransformations(mappedLine);
            }
        }
    }

    public hideLines() {
        if (this.mappingBoards) {
            ServiceRoleComponent.hideLines(this.mappingBoards);
        }
    }
    public showLines() {
        this.tempSelectedBoard = null;
        this.tempSelectedBoardFilters = null;
        if (this.mappingBoards) {
            this.handleScroll();
        }
    }

    public openEntriesFilters(event) {
        if (event && event.type) {
            this.hideLines();
            this.tempSelectedBoard = event.type;
            this.tempSelectedBoardFilters = this.bot.inputFieldsFilter;
        }
    }

    public updateDeterminantFilter(event) {
        if (event && event.filters) {
            if (event?.filters.length === 1 && event?.filters[0].items.length < 1) {
                this.bot.inputFieldsFilter = null;
            } else {
                this.bot.inputFieldsFilter = event.filters;
            }
        }
        this.showLines();
        this.saveData.emit();
    }

    public updateQueryFilter(event) {
        if (event && event.filters) {
            this.bot.inputQueryFilter = event.filters;
        }
        if (event.showLines) {
            this.showLines();
        }
        this.saveData.emit();
    }
}
